import { ADD_PROFILE, ADD_CURRENT_ROUTE } from '../actionTypes';

export default function (state = [], action) {
    switch (action.type) {
        case ADD_PROFILE:
            return action.profile;
        
        case ADD_CURRENT_ROUTE:
            return action.profile;
        
        default:
            return state;
    }
};